import React, {FunctionComponent} from 'react';
import Pnotify from 'pnotify'


import Modal from '../../../ui/Modal/Modal';
import Links from './Links/Links';
import { analytics } from '../../../..';
import { AnalyticsEvents } from '../../../../store/AnalyticsStore';

interface ILinksModal {
    onClose: () => void;
}

const LinksModal:FunctionComponent<ILinksModal> = ({onClose}) => {

    const copyToClipboard = () => {
        analytics.logEvent(AnalyticsEvents.PressCopyLink)

        const createdLink = document.getElementById('link');
        const selection = getSelection();
        if(createdLink && selection) selection.selectAllChildren(createdLink);

        document.execCommand('copy');
        new Pnotify({
            title: 'Success!',
            text: 'Link was copied!',
            addclass: 'bg-success',
            buttons: { closer_hover: true }
        })
    };

    const buttons = (
        <button
            type="button"
            className="btn btn-primary btn-form"
            onClick={copyToClipboard}
        >
            Copy
        </button>
    );

    return (
        <Modal
            header = "Links"
            onClose = {onClose}
            buttons = {buttons}
        >
            <Links/>
        </Modal>
    )
};

export default LinksModal;